import { useEffect } from 'react';
import { BackHandler, Platform } from 'react-native';
import { useUnsavedChangesStore } from '../stores/useUnsavedChangesStore';

export function UnsavedChangesBeforeUnloadListener() {
  useEffect(() => {
    if (Platform.OS !== 'web') return;

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      const { hasDirtyForms } = useUnsavedChangesStore.getState();
      if (hasDirtyForms()) {
        event.preventDefault();
        event.returnValue = '';
        return '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    if (Platform.OS !== 'android') return;

    const handleBackPress = () => {
      const { hasDirtyForms, guard } = useUnsavedChangesStore.getState();
      if (hasDirtyForms()) {
        guard(() => {
          BackHandler.exitApp();
        });
        return true;
      }
      return false;
    };

    const subscription = BackHandler.addEventListener(
      'hardwareBackPress',
      handleBackPress,
    );
    return () => {
      subscription.remove();
    };
  }, []);

  return null;
}
